// src/pages/cities/EditCity.jsx
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { CircularProgress, Box } from "@mui/material";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import FormAddEditCity from "../../components/cities/FormAddEditCity";
import useGetCity from "../../hooks/cities/useGetCity";

const EditCity = () => {
    const navigate = useNavigate();
    const { id } = useParams();

    const { isLoading, city } = useGetCity(id);

    if (isLoading) {
        return (
            <WrapperSection>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: "400px",
                    }}
                >
                    <CircularProgress />
                </Box>
            </WrapperSection>
        );
    }

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditCity
                isEdit={true}
                currentData={city}
                onSubmitSuccess={() => navigate("/cities")}
            />
        </WrapperSection>
    );
};

export default EditCity;
